import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: 24px;
  align-items: center;

    a {
      display: inline-flex;
      text-decoration: none;
    }
    
    p {
      line-height: 20px;
      font-size: 13px;
      color: #0182cd;
      font-weight: 500;
      margin-left: 5px;
    }
`;
